<template>
  <b-container>
    <div class="row mb-3">
      <div class="col-lg-6 col-sm-11 pl-0 text-right">{{ title }}</div>
      <div class="col-lg-6 col-sm-1 text-left">

        <router-link :to="{ name: 'Brand' }" class="ml-2">
          <b-button pill variant="purple"> بازگشت به صفحه برند ها</b-button>
        </router-link>

      </div>
    </div>
    <form @submit.prevent="onSubmit">

      <div class="row pt-2">


        <form-group class="col text-right Font" :validations="$v.form.preview">
          <div slot-scope="{ errors, invalid }">


            <b-form-file
                browse-text="انتخاب عکس"
                @change="onFileChange"
                class="text-center"
                v-model="form.image"
                placeholder="انتخاب عکس"
                drop-placeholder="انتخاب عکس"
            ></b-form-file>

            <input id="brand-image" type="hidden" @change="onFileChange"/>

            <div id="preview" class="mt-2">
              <img alt="" v-if="form.preview" width="300" height="300" :src="form.preview"/>
            </div>

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>


      </div>

      <b-col lg="12" class="mt-5 mb-5">
        <b-form-row>
          <form-group class="col-lg-4 col-md-4 mb-3 text-right Font" :validations="$v.form.name">
            <div slot-scope="{ errors, invalid }">
              <label>نام</label>

              <input v-model="form.name" type="text" class="form-control">

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>


          <form-group class="col-lg-4 col-md-4 mb-3 text-right Font" :validations="$v.form.slug">
            <div slot-scope="{ errors, invalid }">
              <label>slug</label>
              <input v-model="form.slug" type="text" class="form-control">
              <form-errors-manager :errors="errors"/>
            </div>

          </form-group>

          <languageBox class="col-lg-4 col-md-4   " v-model="form.language_id" :validation="$v.form.language_id"/>

          <form-group class="col-lg-12 col-md-6 mb-3 text-right Font" :validations="$v.form.description">
            <div slot-scope="{ errors, invalid }">
              <label>توضیحات</label>
              <textarea v-model="form.description" type="text" class="form-control ml-auto mr-auto col-lg-12"
                        rows="8"></textarea>
              <form-errors-manager :errors="errors"/>
            </div>

          </form-group>


        </b-form-row>
      </b-col>


      <button type="submit" class="btn color-btn mt-2 w-100">ثبت</button>


    </form>


  </b-container>
</template>

<script>
import FormGroup from "../../validator/FormGroup";
import FormErrorsManager from "../../validator/FormErrorsManager";
import {required} from "vuelidate/lib/validators";
import {slug} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import languageBox from "../Language/LanguageBox";

export default {
  name: "CreateLayout",
  props: ['title', 'submitFunction'],
  components: {FormGroup, FormErrorsManager, languageBox},
  data() {
    return {
      form: {
        name: '',
        slug: '',
        image: [],
        preview: '',
        description: '',
        language_id: ''
      },
    }
  },
  validations: {
    form: {
      name: {required},
      slug: {required, slug},
      preview: {required},
      language_id: {required},
      description: {},
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        console.log(this.form)
        const form = this.form
        this.submitFunction(form)
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.image = file;
      this.form.preview = URL.createObjectURL(file);
    },
  },
  mounted() {
    const routerSlug = this.$route.params.slug;
    let language_id = this.findAttributeOnSiteInfo('default_language')[0].id
    if (routerSlug !== undefined) {
      this.form.slug = routerSlug;
      const form = this.form
      this.$store.dispatch('Brand/showBrand', form).then(async res => {
        const brand = res.data.data;
        this.form.name = brand.name;
        this.form.id = brand.id;
        this.form.slug = brand.slug;
        this.form.description = brand.description;
        this.form.preview = brand.image;
        this.form.image = []
        language_id = await brand.language_id;
        document.getElementById(`language_item_${language_id}`).click();

      }).catch(err => {
        this.$router.push({name: 'Brand'})
      })
    } else {
      document.getElementById(`language_item_${language_id}`).click();
    }
  },
}
</script>

<style scoped>
.color-btn {
  background-color: #bf61ee;
  border: none;
  color: white;
}

.Font {
  font-size: 0.8rem;
}


#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  max-height: 500px;
}

</style>